export class CustomStatus {
    id: number
    code: string
    name: string
    type: string
  }

export interface ListCustomerCardsInterface {
  [key: string]: string | number | Date;
}